<div class="lg:table-cell py-1 lg:py-5 px-2">
    <div class="text-xs font-semibold lg:hidden">{{ 'deliverynotes_table_num' | translate }}:</div>
    {{ item?.numero }}
</div>
<div class="lg:table-cell py-1 lg:py-5 px-2">
    <div class="text-xs font-semibold lg:hidden">{{ 'deliverynotes_table_serie' | translate }}:</div>
    {{ item?.serie }}
</div>
<div class="lg:table-cell py-1 lg:py-5 px-2">
    <div class="text-xs font-semibold lg:hidden">{{ 'deliverynotes_table_order' | translate }}:</div>
    {{ item?.pedido }}
</div>
<div class="lg:table-cell py-1 lg:py-5 px-2">
    <div class="text-xs font-semibold lg:hidden">{{ 'deliverynotes_table_date' | translate }}:</div>
    {{ item?.fecha | moment: 'DD/MM/YYYY' }}
</div>
<div class="lg:table-cell py-1 lg:py-5 px-2">
    <div class="text-xs font-semibold lg:hidden">{{ 'deliverynotes_table_ca' | translate }}:</div>
    {{ item?.cargoAbono }}

</div>
<div class="lg:table-cell py-1 lg:py-5 px-2">
    <div class="text-xs font-semibold lg:hidden">{{ 'deliverynotes_table_store' | translate }}:</div>
    {{ item?.almacen }}
</div>
<div class="lg:table-cell py-1 lg:py-5 px-2">
    <div class="text-xs font-semibold lg:hidden">{{ 'deliverynotes_table_raw' | translate }}:</div>
    {{ item?.bruto | currency:(usersService.currency$ | async):'symbol':'1.2-2' }}
</div>
<div class="lg:table-cell py-1 lg:py-5 px-2">
    <div class="text-xs font-semibold lg:hidden">{{ 'deliverynotes_table_total' | translate }}:</div>
    {{ item?.neto | currency:(usersService.currency$ | async):'symbol':'1.2-2' }}
</div>
<div class="lg:table-cell py-1 lg:py-5 px-2">
    <div class="text-xs font-semibold lg:hidden">{{ 'deliverynotes_table_delivery' | translate }}:</div>
    Cons.
</div>

<div class="md:col-span-3 lg:table-cell py-5 px-2">
    <div class="flex items-center justify-end gap-5">
        <!-- PDF -->
        <button (click)="clickDownloadDeliveryNote($event)" class="flex items-center gap-1 hover:underline" title="Descargar factura">
            <ng-container *ngIf="!loading">
                <img src="./assets2023/img/icons/download.svg" alt="Descargar PDF" width="32" height="32" />
                PDF
            </ng-container>
            <app-spinner *ngIf="loading" [onlySVG]="true" color="text-primary"></app-spinner>
        </button>

        <!-- Incidents -->
        <button class="group" title="Incidencias" (click)="clickNewIncidence()">
            <svg class="stroke-primary group-hover:stroke-white group-hover:fill-primary"
                width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_558_37972)">
                    <path d="M9.24022 2.79706L2.22188 14.5137C2.07728 14.7643 2.00079 15.0484 2.00001 15.3377C1.99923 15.627 2.07419 15.9115 2.21744 16.1628C2.36069 16.4142 2.56724 16.6237 2.81655 16.7705C3.06586 16.9173 3.34925 16.9962 3.63855 16.9996H17.6761C17.9653 16.9962 18.2487 16.9173 18.4981 16.7705C18.7474 16.6237 18.9539 16.4142 19.0972 16.1628C19.2404 15.9115 19.3154 15.627 19.3146 15.3377C19.3138 15.0484 19.2373 14.7643 19.0927 14.5137L12.0736 2.79706C11.9258 2.55372 11.7178 2.35255 11.4696 2.21294C11.2215 2.07334 10.9416 2 10.6569 2C10.3722 2 10.0923 2.07334 9.84414 2.21294C9.596 2.35255 9.38802 2.55372 9.24022 2.79706Z" stroke="#0A123A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M10.707 7V10.3333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M10.707 13.6641H10.7158" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
                <defs>
                    <clipPath id="clip0_558_37972">
                        <rect width="20" height="20" fill="white"/>
                    </clipPath>
                </defs>
            </svg>
        </button>
    </div>
</div>
